import { render, staticRenderFns } from "./Cookies.vue?vue&type=template&id=3e562d05&scoped=true&"
import script from "./Cookies.js?vue&type=script&lang=js&"
export * from "./Cookies.js?vue&type=script&lang=js&"
import style0 from "./Cookies.scss?vue&type=style&index=0&id=3e562d05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e562d05",
  null
  
)

export default component.exports